import dkAxios from '@/jslib/dk-axios'

export const getAfterSaleList = data => dkAxios({
  url: '/v1/cms/AfterSale',
  method: 'GET',
  params: data,
});

export const getAfterSaleDetail = data => dkAxios({
  url: '/v1/cms/AfterSale/getAfterSaleDetail',
  method: 'POST',
  params: data,
});

export const setComplete = data => dkAxios({
  url: '/v1/cms/AfterSale/setComplete',
  method: 'POST',
  params: data,
});



// WEBPACK FOOTER //
// ./src/api/after-sale.js